import { useMemo } from 'react'

import type { ObjectiveWithProgress } from '@/types/objective'

import { useObjectives } from './useObjectives'
import { partitionObjectives } from '../model/progress'

export const useObjectivesListView = () => {
  const {
    goals,
    objectives,
    completedCount,
    totalCount,
    overallPercent,
    totalPossibleCoins,
    earnedCoins,
    isLoading
  } = useObjectives()

  const groups = useMemo(() => partitionObjectives(goals), [goals])

  return {
    groups,
    goals,
    objectives,
    completedCount,
    totalCount,
    overallPercent,
    totalPossibleCoins,
    earnedCoins,
    isLoading,
    isEmpty: !isLoading && goals.length === 0
  }
}

export type { ObjectiveWithProgress }
